import { render, staticRenderFns } from "./BatteryImg.vue?vue&type=template&id=52160c6c&scoped=true"
import script from "./BatteryImg.vue?vue&type=script&lang=js"
export * from "./BatteryImg.vue?vue&type=script&lang=js"
import style0 from "./BatteryImg.vue?vue&type=style&index=0&id=52160c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52160c6c",
  null
  
)

export default component.exports